import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { t } from "i18next";
import api from "../../../../helpers/api/Api";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import RouteUrls from "../../../../helpers/urls/RouteUrls";
import Table from "../../../../components/Tables/Table";
import DisabledSwitch from "../../../../components/DisabledSwitch";
import DeleteButton from "../../../../components/DeleteButton";
import KeyManagement from "./components/keyManagement";
import DomainTableSearch from "./components/search";
import DomainSelectMore from "./components/domainSelectMore";
import PagePermBits from "../../../../helpers/constants/PagePermBits";

function DomainManagement() {
  const use_dispatch = useDispatch();
  const userType = JSON.parse(localStorage.getItem("user"))?.type;
  const [listReload, setListReload] = useState(0);
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: t("domain.domain_address"), accessor: "name", align: "left" },
    { Header: t("domain.source_ip"), accessor: "srcip", align: "center" },
    { Header: t("domain.owner"), accessor: "owner", align: "center" },
    { Header: t("domain.certificate_management"), accessor: "keyManagement", align: "center" },
    { Header: t("global.status"), accessor: "disabled", align: "center" },
    { Header: t("global.edit"), accessor: "edit", align: "center", width: '10%' },
    ...(userType != 1) ? [{ Header: t("global.delete"), accessor: "delete", align: "center", width: '10%' }] : [],
    ...(userType == 0 || userType == 1) ? [{ Header: t("global.actions"), accessor: "actions", align: "center", width: '10%' }] : [],
  ];
  const [formData, setFormData] = useState({
    search: "",
    userid: ""
  });

  const setDataList = (data) => {
    const temp_rows = data.map((domain) => {
      return (
         {
           name: returnDomains(domain.name),
           srcip: returnSrcIP(domain),
           owner: domain.ownername,
           keyManagement: (<KeyManagement domain={domain} />),
           disabled: (
              <DisabledSwitch
                 item={domain}
                 itemName={t("domain.domain")}
                 itemCName={t("domain.domain_disable")}
                 disableUrl={ApiUrls.domain.edit}
              />
           ),
           edit: (
              <IconButton href={`${RouteUrls.domain.edit}?id=${domain.id}`}>
                <Edit />
              </IconButton>
           ),
           delete: (
              <DeleteButton
                 item={domain}
                 itemName={t("domain.domain")}
                 deleteUrl={ApiUrls.domain.delete}
                 handleCloseModal={handleCloseModal}
              />
           ),
           actions: (
              <DomainSelectMore
                 domain={domain}
                 handleCloseModal={handleCloseModal}
              />
           )
         }
      )});

    setRows(temp_rows);
  }

  const returnDomains = (domains) => {
    const domainArr = domains.split(" ");
    return (
       <div className="">
         {domainArr.map((d, i) => {
           return (
              <div key={i}>{d}</div>
           );
         })}
       </div>
    )
  }

  const returnSrcIP = (domain) => {
    return (
       <div className="ltr-div">
         <div>{`${domain.srcip}:${domain.srcport}`}</div>
         {domain.ishttps === "1" &&
            <div>{`${domain.srcip}:${domain.srchttpsport}`}</div>
         }
       </div>
    )
  }

  const handleCloseModal = () => {
    setListReload(listReload+1);
  }

  useEffect(() => {
    getDomainsList();
  }, []);

  const getDomainsList = () => {
    api.post(ApiUrls.domain.list, {})
       .then((response) => {
         use_dispatch({
           type: "SET_DOMAIN_LIST",
           payload: response.data.data
         });
       })
       .catch((error) => {});
  }

  return (
     <Table
        columns={columns}
        rows={rows}
        setDataList={setDataList}
        listReload={listReload}
        addUrl={RouteUrls.domain.add}
        getListUrl={ApiUrls.domain.list}
        itemName={t("domain.domain")}
        itemPName={t("domain.domains")}
        search={
          <DomainTableSearch
             formData={formData}
             setFormData={setFormData}
          />
        }
        formData={formData}
        setFormData={setFormData}
        listPermBit={PagePermBits.domainManagement}
     />
  );
}

export default DomainManagement;
